import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// import { getWyList } from '../../../services/api';
// import { rel } from '../../utils/rel';

/**
 * 定义 委员列表 组件
 */

class PeopList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        // console.log('lettrlist==', list);

        const peoMap =
            content && content.map
                ? content.map((item, index) => {
                      return index % 3 === 2 ? (
                          <li key={index} className={styles.authornoR}>
                              <a href={item.feng_url}>
                                  <img src={item.image} className={styles.uitemImg} />
                                  <p className={styles.auitemP}>{item.name}</p>
                              </a>
                          </li>
                      ) : (
                          <li key={index} className={styles.auitem}>
                              <a href={item.feng_url}>
                                  <img src={item.image} className={styles.uitemImg} />
                                  <p className={styles.auitemP}>{item.name}</p>
                              </a>
                          </li>
                      );
                  })
                : '';

        return <ul className={styles.aulist}>{peoMap}</ul>;
    }
}

PeopList.propTypes = { content: PropTypes.array };
export default errorBoundary(PeopList);
